export default [
    {
        // [0]
        key: "employee_id",
        label: "Employee",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "status",
        label: "Status",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "discount_type_id",
        label: "Type",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "total",
        label: "Amount",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "quotas",
        label: "Quotas",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "created_by",
        label: "Created By",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "user_authorized",
        label: "Aprobado Por",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "observation",
        label: "Observation",
        visible: true,
    },
    {
        // [4]
        key: "sustento",
        label: "Sustento",
        visible: true,
    },
    {
        // [13]
        key: "actions",
        label: "Actions",
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]